import React, { useState, useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { FaEdit, FaEye } from 'react-icons/fa';
import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastHelper';
import { fetchCountries, fetchGovernments, clearError, clearSuccess } from '../../../redux/Slices/LocationsSlice';

const Governments = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { countries, governments, loading, error, success } = useSelector((state) => state.locations);
    const [selectedCountryId, setSelectedCountryId] = useState('');

    useEffect(() => {
        setTitle('المحافظات');
        dispatch(fetchCountries());
    }, [setTitle, dispatch]);

    // Fetch governments when country selected
    useEffect(() => {
        if (selectedCountryId) {
            dispatch(fetchGovernments(selectedCountryId));
        }
    }, [selectedCountryId, dispatch]);

    // Once countries loaded, select first one by default if none selected
    useEffect(() => {
        if (countries && countries.length > 0 && !selectedCountryId) {
            setSelectedCountryId(countries[0].id);
        }
    }, [countries, selectedCountryId]);

    useEffect(() => {
        if (error) {
            showErrorToast(error);
            dispatch(clearError());
        }
        if (success) {
            showSuccessToast(success);
            dispatch(clearSuccess());
        }
    }, [error, success, dispatch]);

    const handleEdit = (id) => navigate(`/admin-locations/governments/${id}/edit`);
    const handleView = (id) => navigate(`/admin-locations/governments/${id}`);
    const handleAdd = () => navigate(`/admin-locations/governments/add`);

    return (
        <div className="main_content">
            <div className="dashboard-container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="mb-0">إدارة المحافظات</h4>
                    <button className="btn btn-primary px-4 py-2" onClick={handleAdd}>
                        إضافة محافظة +
                    </button>
                </div>

                <div className="card shadow-lg border-0 mb-4">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-4">
                                <label className="form-label fw-bold">اختر الدولة ل عرض المحافظات:</label>
                                <select 
                                    className="form-select"
                                    value={selectedCountryId}
                                    onChange={(e) => setSelectedCountryId(e.target.value)}
                                >
                                    <option value="" disabled>-- اختر الدولة --</option>
                                    {countries && countries.map(country => (
                                        <option key={country.id} value={country.id}>
                                            {country.name_ar || country.name || country.name_en}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {selectedCountryId && (
                    <div className="card shadow-lg border-0">
                        <div className="card-body">
                            {loading && (!governments || governments.length === 0) ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-3 text-muted">جاري تحميل المحافظات...</p>
                                </div>
                            ) : !governments || governments.length === 0 ? (
                                <div className="text-center py-5">
                                    <p className="text-muted">لا توجد محافظات مضافة لهذه الدولة</p>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-modern">
                                        <thead>
                                            <tr>
                                                <th className="text-center">الرقم التعريفي</th>
                                                <th className="text-center">اسم المحافظة</th>
                                                
                                                <th className="text-center">الإجراءات</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {governments.map((gov) => {
                                                const country = countries.find(c => String(c.id) === String(gov.country_id)) || {};
                                                return (
                                                <tr key={gov.id} className="table-row-modern">
                                                    <td className="text-center">
                                                        <div className="order-number-badge">{gov.id}</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="category-name">
                                                            {gov.name_ar || gov.name_en || gov.name || 'غير محدد'}
                                                        </div>
                                                    </td>
                                                   
                                                    <td className="text-center">
                                                        <div className="action-buttons">
                                                            <motion.button
                                                                whileHover={{ scale: 1.1, y: -2 }}
                                                                whileTap={{ scale: 0.95 }}
                                                                className="btn btn-success"
                                                                style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px' }}
                                                                onClick={() => handleView(gov.id)}
                                                                title="عرض">
                                                                <FaEye color="white" />
                                                            </motion.button>
                                                            <motion.button
                                                                whileHover={{ scale: 1.1, y: -2 }}
                                                                whileTap={{ scale: 0.95 }}
                                                                className="btn btn-warning"
                                                                style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px' }}
                                                                onClick={() => handleEdit(gov.id)}
                                                                title="تعديل">
                                                                <FaEdit color="white" />
                                                            </motion.button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )})}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Governments;
